import React from 'react';

import EditIcon from "@usas/ui-web/components/icons/EditIcon";

import { CURRENCY_FORMATTER } from '@usas/ui-web/utils/Constants';
import { formatDate } from "@usas/ui-web/utils/DateFunctions";

import Constants from '@usas/ui-web/utils/Constants';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ contract, onEdit }) => (
  <tr>
    <td>{contract.satDate ? formatDate(contract.satDate) : ''}</td>
    <td>{contract.contractStatus?.statusDescription || ''}</td>
    <td>{contract.fundraisingGoal ? CURRENCY_FORMATTER.format(contract.fundraisingGoal) : ''}</td>
    <td>{contract.signatureDate ? formatDate(contract.signatureDate) : ''}</td>
    <td>{contract.fulfillmentDate ? formatDate(contract.fulfillmentDate) : ''}</td>
    <td>
      {onEdit && contract.contractStatus.statusDescription !== "Canceled" &&
        <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, contract)}>
          <EditIcon />
        </button>
      }
    </td>
  </tr>
);

const SATContractsGridLarge = ({ data, isLoading, onEdit }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Swim-a-Thon Date</th>
        <th>Contract Status</th>
        <th>Fundraising Goal</th>
        <th>Signature Date</th>
        <th>Fulfillment Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true
        ? (
          <tr>
            <td colSpan="6">Loading...</td>
          </tr>
        ) : Array.isArray(data) && data.length > 0
          ? data.map((contract, i) => (
            <GridRow
              key={i}
              contract={contract}
              onEdit={onEdit} />
          )) : (
            <tr>
              <td colSpan="6">No Contracts</td>
            </tr>
          )
      }
    </tbody>
  </table>
);

export default SATContractsGridLarge;